/**
 * Switch Node Component
 */
import React, { memo } from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { ToggleLeft } from 'lucide-react';
import styles from './Nodes.module.css';

export const SwitchNode: React.FC<NodeProps> = memo(({ data, selected }) => {
  return (
    <div className={`${styles.node} ${styles.switchNode} ${selected ? styles.selected : ''}`}>
      <Handle
        type="target"
        position={Position.Left}
        className={styles.handle}
      />
      <div className={styles.nodeContent}>
        <div className={styles.nodeIcon} style={{ backgroundColor: '#1d4ed8' }}>
          <ToggleLeft size={16} color="white" />
        </div>
        <div className={styles.nodeDetails}>
          <span className={styles.nodeLabel}>{data.label || 'Switch'}</span>
          {data.cases && (
            <span className={styles.nodeSubtitle}>{data.cases.length} cases</span>
          )}
        </div>
      </div>
      <Handle
        type="source"
        position={Position.Right}
        className={styles.handle}
      />
    </div>
  );
});

SwitchNode.displayName = 'SwitchNode';
